<template>
    <div class="account-balance padded-page" ref="screenWrapper">
        <div class="mb-5 text-white font-satoshi_r max-w-xs">
            <p class="text-lg">Your average account balance was</p>
            <p class="text-4xl font-satoshi_b font-bold my-2">
                <CountUpNumber :endVal="reviewData?.avg_monthly_balance ?? 0" currency="₦" />
            </p>
            <p v-if="reviewData?.avg_monthly_balance > 1000">
                You had more funds in <span class="font-satoshi_b">{{ reviewData?.top_balance_month.trim() }}</span> compared to any other month in
                2025.
            </p>
            <p v-else>Your balance could use a little boost! A higher balance means more wallet interest earnings.</p>
        </div>
        <img :src="balanceCoinImage" class="mx-auto" alt="balance" />
        <img :src="balanceChartImage" class="mx-auto block -mt-10" alt="balance" />
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    computed: {
        balanceCoinImage() {
            return this.reviewData?.avg_monthly_balance > 1000
                ? require("../../assets/images/year-in-review/balance-coin.svg")
                : require("../../assets/images/year-in-review/balance-coin-low.svg");
        },

        balanceChartImage() {
            return this.reviewData?.avg_monthly_balance > 1000
                ? require("../../assets/images/year-in-review/balance-chart.svg")
                : require("../../assets/images/year-in-review/balance-chart-low.svg");
        },
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.account-balance {
    padding: 16px 0px;
    color: #fcfcde;
    background-color: #399dbf;
    background-image: url("../../assets/images/year-in-review/cover-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    min-height: 100vh;
}
</style>
